module.exports = __webpack_public_path__ + "static/media/close_black.ca69ec48.svg";